import api from './api';
import {buildUrl} from '../utils';
import {prepareMetaData} from '../../utils/helpers/api';
import {
  preparePropertyRemarketingListProps,
  preparePropertyDetailProps,
} from '../../utils/helpers/property';

const getProperties = (builder, {path}) =>
  builder.query({
    providesTags: ['PROPERTY_LIST'],
    query: ({options = {}} = {}) => buildUrl(`${path}`, options),
    transformResponse: (response, _, {options = {}}) => {
      const {withPrepared = false, onlyPrepared = false} = options;
      const {data, meta} = response;
      return {
        data:
          onlyPrepared && !withPrepared
            ? preparePropertyRemarketingListProps(data)
            : data,
        meta: prepareMetaData(meta),
        ...(withPrepared && {
          prepared: preparePropertyRemarketingListProps(data),
        }),
      };
    },
  });

const propertyDetails = (builder, {path}) =>
  builder.query({
    query: ({id} = {}) => `${path}/${id}`,
    transformResponse: ({data}, _, {options = {}}) => {
      const {withPrepared = false, onlyPrepared = false} = options;
      const prepared = preparePropertyDetailProps(data);
      return {
        data: onlyPrepared && !withPrepared ? prepared : data,
        ...(withPrepared && {prepared}),
      };
    },
  });

const propertiesExists = (builder, {path}) =>
  builder.query({
    query: () => `${path}/check`,
    transformResponse: ({data}) => Boolean(data.success),
    providesTags: ['PROPERTIES_CHECK'],
  });

export const config = {
  path: `/tenant/properties`,
};

const propertyApi = api.injectEndpoints({
  endpoints: builder => ({
    getProperties: getProperties(builder, config),
    propertyDetails: propertyDetails(builder, config),
    propertiesExists: propertiesExists(builder, config),
  }),
});

export const {
  useGetPropertiesQuery,
  usePropertyDetailsQuery,
  usePropertiesExistsQuery,
  useLazyPropertiesExistsQuery,
} = propertyApi;

export default propertyApi;
